module.exports = __webpack_public_path__ + "static/media/howToScheme-mob.a155ffba.png";